<template>
    <card
            class-content="pl-2 pr-2"
            class-label="pr-0"
            :label-top-left="$t('msg.weeklyPlan')+', '+getNameWeek()"
            label-raw
            icon="mdi-calendar-range"
            small
    >
        <template v-slot:header>
            <v-btn
                    fab
                    small
                    color="primary"
                    @click="$refs.weekPlanForm.createModel(getWeek())"
                    class="mr-2"
                    elevation="0"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn
                    fab
                    small
                    dark
                    color="primary"
                    @click="$refs.weekAssistant.open(getWeek(), getMonth())"
                    elevation="0"
            >
                <v-icon size="20">mdi-backburger</v-icon>
            </v-btn>
        </template>
        <plan
                :items="items"
                :item-as-link="true"
                @click-item="$refs.weekPlanForm.openModel($event)"
                :mark-action-true="'changeWeekPlanDone'"
                :mark-action-false="'changeWeekPlanDone'"
                :mark-custom-payload="markCustomPayload"
                :loading="loading"
        ></plan>
        <week-plan-form
                ref="weekPlanForm"
                :projects="projects"
                :notes="notes"
                @saved="loadWeekPlans()"
        ></week-plan-form>
        <week-assistant
                :items="items"
                ref="weekAssistant"
                @saved="loadWeekPlans()"
        ></week-assistant>
    </card>
</template>

<script>
    import Plan from "./Plan";
    import WeekPlanForm from "./WeekPlanForm";
    import WeekAssistant from "./WeekAssistant";
    import {format, startOfWeek, endOfWeek} from 'date-fns';

    export default {
        components: {Plan, WeekPlanForm, WeekAssistant},
        props: {
            projects: Array,
            notes: Array,
            selectedDay: Date
        },
        data() {
            return {
                items: [],
                loading: false
            }
        },
        watch: {
            selectedDay() {
                this.loadWeekPlans();
            }
        },
        methods: {
            getMonth() {
                return format(this.selectedDay, 'yyyyMM');
            },
            getWeek() {
                let start = startOfWeek(this.selectedDay, {weekStartsOn: 1});
                let end = endOfWeek(this.selectedDay, {weekStartsOn: 1});
                return format(start, 'yyyyMMdd')+format(end, 'yyyyMMdd');
            },
            getNameWeek() {
                let start = startOfWeek(this.selectedDay, {weekStartsOn: 1});
                let end = endOfWeek(this.selectedDay, {weekStartsOn: 1});
                let monthStart = format(start, 'MMMM');
                let dayStart = format(start, 'd');
                let monthEnd = format(end, 'MMMM');
                let dayEnd = format(end, 'd');
                return '<b>' + dayStart + ' ' + this.$t('monthNameNum.'+monthStart) + ' - ' +
                    dayEnd + ' ' + this.$t('monthNameNum.'+monthEnd) + '</b>';
            },
            loadWeekPlans() {
                this.loading = true;
                this.$store.dispatch('loadWeekPlans', {
                    params: {week: this.getWeek()}
                })
                    .then(res => this.items = res)
                    .finally(() => this.loading = false);
            },
            markCustomPayload(payload, id, value) {

                payload.data = {
                    value
                };

                let index = this.items.map(v => v.id).indexOf(id);

                if (typeof this.items[index].task_id === 'number') {
                    if (confirm(this.$t('msg.markRelatedTask')+'?')) {
                        payload.data.task_id = this.items[index].task_id;
                    }
                }

                return payload
            }
        },
        created() {
            this.loadWeekPlans();
        }
    }
</script>